/**
 * Empty State Component for Expense Invoices
 * Displayed when list is empty or no results from filters
 */

import React from 'react';
import { Box, Typography, Button, Stack } from '@mui/material';
import InboxIcon from '@mui/icons-material/Inbox';
import AddIcon from '@mui/icons-material/Add';
import FilterListOffIcon from '@mui/icons-material/FilterListOff';

interface EmptyStateProps {
  hasFilters?: boolean;
  onClearFilters?: () => void;
  onCreate?: () => void;
}

export const EmptyState: React.FC<EmptyStateProps> = ({
  hasFilters = false,
  onClearFilters,
  onCreate,
}) => {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: 300,
        py: 6,
        px: 3,
        textAlign: 'center',
      }}
    >
      <InboxIcon sx={{ fontSize: 80, color: 'text.disabled', mb: 2 }} />

      {hasFilters ? (
        <>
          <Typography variant="h6" color="text.secondary" gutterBottom>
            Brak wyników
          </Typography>
          <Typography variant="body2" color="text.secondary" sx={{ mb: 3, maxWidth: 400 }}>
            Nie znaleziono faktur pasujących do wybranych filtrów. Spróbuj zmienić kryteria
            wyszukiwania.
          </Typography>
          {onClearFilters && (
            <Button variant="outlined" startIcon={<FilterListOffIcon />} onClick={onClearFilters}>
              Wyczyść filtry
            </Button>
          )}
        </>
      ) : (
        <>
          <Typography variant="h6" color="text.secondary" gutterBottom>
            Brak faktur kosztowych
          </Typography>
          <Typography variant="body2" color="text.secondary" sx={{ mb: 3, maxWidth: 400 }}>
            Nie masz jeszcze żadnych faktur kosztowych. Dodaj pierwszą fakturę ręcznie lub
            zaimportuj przez OCR.
          </Typography>
          {onCreate && (
            <Stack direction="row" spacing={2}>
              <Button variant="contained" startIcon={<AddIcon />} onClick={onCreate}>
                Dodaj fakturę
              </Button>
            </Stack>
          )}
        </>
      )}
    </Box>
  );
};
